import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

// Assets'teki görselleri import edelim
import image1 from '../assets/1.jpeg';
import image2 from '../assets/2.jpeg';
import image3 from '../assets/3.jpeg';
import image4 from '../assets/4.jpeg';
import videoFile from '../assets/video.mp4';
import mobile1 from '../assets/mobilview/11.png';
import mobile2 from '../assets/mobilview/112.png';
import mobile3 from '../assets/mobilview/113.jpg';
import logo from '../assets/logo.png';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);


  useEffect(() => {
    // Scroll animasyonları için observer
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Animate edilecek elementleri seç
    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };



  return (
    <div className="homepage">
      {/* Header */}
      <header className="header animate-slide-down">
        <div className="container">
          <div className="nav">
            <nav className={`navigation ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <img src={logo} alt="Taxicim Logo" className="nav-logo" />
              <a href="#home" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Ana Sayfa</a>
              <a href="#about" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Hakkımızda</a>
              <a onClick={() => navigate('/destek')} className="nav-link" style={{cursor: 'pointer'}}>🛠️ Destek</a>
              <a onClick={() => navigate('/privacy-policy')} className="nav-link" style={{cursor: 'pointer'}}>KVKK</a>
              <a onClick={() => navigate('/terms-of-service')} className="nav-link" style={{cursor: 'pointer'}}>Kullanım Koşulları</a>
            </nav>
            <div className="header-right">
              <div className="auth-buttons">
                <button 
                  className="login-btn pulse-animation"
                  onClick={() => navigate('/login')}
                >
                  Giriş Yap
                </button>
                <button 
                  className="driver-btn pulse-animation"
                  onClick={() => navigate('/driver-registration')}
                >
                  Sürücü Ol
                </button>
                <button 
                  className="passenger-btn pulse-animation"
                  onClick={() => navigate('/passenger-registration')}
                >
                  Yolcu Ol
                </button>
              </div>
              <button 
                className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
                onClick={toggleMobileMenu}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero" id="home">
        <div className="hero-background"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text animate-fade-in-left">
              <h1 className="hero-title">
                <span className="gradient-text">Taxicim</span> Sana En Yakın Taksileri Listeler
              </h1>
              <div className="hero-subtitle">
                <h2 className="typing-animation">Taxicim & Sürücü Ortağı Olarak</h2>
                <h2 className="typing-animation delay-1">Yola Çıkmaya Hazır Olun</h2>
              </div>
              <div className="hero-buttons">
                <button 
                  className="register-driver-btn floating-animation"
                  onClick={() => navigate('/driver-registration')}
                >
                  Sürücü Kayıt Ol
                </button>
                <button 
                  className="register-passenger-btn floating-animation delay-2"
                  onClick={() => navigate('/passenger-registration')}
                >
                  Yolcu Kayıt Ol
                </button>
              </div>
            </div>
            <div className="hero-image animate-fade-in-right">
              <div className="app-mockup">
                <div className="video-container">
                  <video 
                    autoPlay 
                    loop 
                    muted 
                    playsInline
                    className="hero-video bounce-animation"
                  >
                    <source src={videoFile} type="video/mp4" />
                    Tarayıcınız video oynatmayı desteklemiyor.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Quick */}
      <section className="features-quick animate-on-scroll">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7L5 6C5 4.89543 5.89543 4 7 4L17 4C18.1046 4 19 4.89543 19 6L19 7M5 7L3 7M5 7L19 7M19 7L21 7M9 11V17M15 11V17M12 11V17" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>🚗 Hediye Fiat Egea</h4>
              <p>5 yılın sonunda tüm şöförlere hediye 0 fiat egea</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>🆓 Ücretsiz Taksi Hizmeti</h4>
              <p>Erken kayıt olana 1 sene boyunca ücretsiz taksi hizmeti</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6312 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6312 13.6815 18 14.5717 18 15.5C18 16.4283 17.6312 17.3185 16.9749 17.9749C16.3185 18.6312 15.4283 19 14.5 19H6" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>💰 İade Puan Sistemi</h4>
              <p>Harcadığın kadar iade puan sistemi</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile App Preview Section */}
      <section className="mobile-app-preview animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Mobil Uygulama</span>
            <h2 className="section-title">Mobil Uygulamamız Çok Yakında Sizlerle</h2>
            <p className="section-description">
              iOS ve Android için özel olarak tasarlanan Taxicim mobil uygulaması ile daha hızlı ve kolay taksi çağırma deneyimi yaşayacaksınız.
            </p>
          </div>
                     <div className="mobile-screenshots">
             <div className="screenshot-item">
               <img src={mobile3} alt="Taxicim Mobil App Ana Sayfa" />
               <div className="screenshot-overlay">
                 <h4>Ana Sayfa</h4>
                 <p>Kullanıcı dostu arayüz</p>
               </div>
             </div>
             <div className="screenshot-item">
               <img src={mobile1} alt="Taxicim Mobil App Harita" />
               <div className="screenshot-overlay">
                 <h4>Harita Görünümü</h4>
                 <p>Gerçek zamanlı takip</p>
               </div>
             </div>
             <div className="screenshot-item">
               <img src={mobile2} alt="Taxicim Mobil App Profil" />
               <div className="screenshot-overlay">
                 <h4>Profil Sayfası</h4>
                 <p>Kişisel ayarlar</p>
               </div>
             </div>
           </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about animate-on-scroll" id="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <span className="section-tag">Hakkımızda</span>
              <h2 className="section-title">"Sizin İçin Varız," Her An Her Yerde</h2>
              <p className="section-description">
                Müşterilerimizin güvenli, konforlu ve hızlı bir ulaşım deneyimi yaşamasını 
                sağlamak için teknolojiyi en iyi şekilde kullanarak, her an her yerde yanındayız.
              </p>
              <div className="contact-info">
                <h4>Taxicim Tüm Sorularınızı Yanıtlıyor.</h4>
                <p>7/24 Ulaşabilirsiniz</p>
                <p className="phone">08502428876</p>
                                  <p>Bizimle iletişime geçmek için: <strong>destek@taxicim.com.tr</strong></p>
              </div>
            </div>
            <div className="about-image">
              <div className="image-wrapper">
                <img src={image1} alt="Taxicim Hakkımızda" className="about-img" />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <h4>Her An Yanındayız</h4>
                    <p>7/24 hizmet</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Gallery Section */}
      <section className="gallery animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Güvenlik & Konfor</span>
            <h2 className="section-title">Taxicim'de Güvenli Yolculuk</h2>
            <p className="section-description">
              Teknolojinin son yenilikleriyle donatılmış araçlarımız ve deneyimli şoförlerimizle
              her yolculuğunuz güvenli ve konforlu
            </p>
          </div>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img src={image2} alt="Taxicim Güvenlik" />
              <div className="overlay">
                <div className="overlay-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4>Güvenli Sürücüler</h4>
                <p>Tüm şoförlerimiz kimlik ve ehliyet kontrolünden geçirilir</p>
              </div>
            </div>
            <div className="gallery-item">
              <img src={image3} alt="Taxicim Konfor" />
              <div className="overlay">
                <div className="overlay-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 8L3 12L7 16M17 8L21 12L17 16M14 4L10 20" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4>Konforlu Araçlar</h4>
                <p>Temiz ve bakımlı araçlarla yolculuk keyfi</p>
              </div>
            </div>
            <div className="gallery-item">
              <img src={image4} alt="Taxicim" />
              <div className="overlay">
                <div className="overlay-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4>Modern</h4>
                <p>GPS takip ve anlık bildirimlerle güvenli ulaşım</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Süreç</span>
            <h2 className="section-title">Taxicim Nasıl Çalışır?</h2>
            <h3 className="section-subtitle">Temel Çalışma Sürecimiz</h3>
          </div>
          <div className="steps">
            <div className="step">
              <div className="step-number">01</div>
              <div className="step-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11" r="8" stroke="#FFC107" strokeWidth="2"/>
                  <path d="M21 21L16.65 16.65" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>Yakınında'ki Taksileri Ara</h4>
              <p>Taksi Arama süreci taksi hizmeti talep etme sürecidir.</p>
            </div>
            <div className="step">
              <div className="step-number">02</div>
              <div className="step-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.3639 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="#FFC107" strokeWidth="2"/>
                  <circle cx="12" cy="10" r="3" stroke="#FFC107" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Taksi Çağır</h4>
              <p>Gideceğin adresi gir fiyata bak ve taksiyi çağır.</p>
            </div>
            <div className="step">
              <div className="step-number">03</div>
              <div className="step-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1" y="3" width="15" height="13" rx="2" ry="2" stroke="#FFC107" strokeWidth="2"/>
                  <path d="M16 8L20 12L16 16" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>Yolculuk ve güvenli ödeme</h4>
              <p>Yolculuğunu bitir ödemeni yap ve sürücüye Puan Ver</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Neden Taxicim?</span>
            <h2 className="section-title">Neden Biz? Güvenlik Önceliğimiz.</h2>
            <p className="section-description">Tüm şoförlerimiz titizlikle seçilmiş ve lisanslıdır</p>
          </div>
          <div className="features">
            <div className="feature">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.3639 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="#FFC107" strokeWidth="2"/>
                  <circle cx="12" cy="10" r="3" stroke="#FFC107" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Konumunuzu Belirleyin</h4>
              <p>Gitmek istediğiniz yeri haritadan seçin veya adresinizi yazın.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 17H4C3.46957 17 2.96086 16.7893 2.58579 16.4142C2.21071 16.0391 2 15.5304 2 15V11C2 9.89543 2.89543 9 4 9H20C21.1046 9 22 9.89543 22 11V15C22 15.5304 21.7893 16.0391 21.4142 16.4142C21.0391 16.7893 20.5304 17 20 17H19M5 17V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V17M5 17H19M7 13H17" stroke="#FFC107" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>Taksiyi Çağırın</h4>
              <p>İhtiyacınıza en uygun taksiyi seçin ve saniyeler içinde çağırın.</p>
            </div>
          </div>
        </div>
      </section>

      {/* App Download Section */}
      <section className="app-download animate-on-scroll">
        <div className="container">
          <div className="download-content">
            <div className="download-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                <line x1="12" y1="18" x2="12.01" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2>Taxicim Uygulamasını Hemen İndirin</h2>
            <h3>Ücretsiz Taxicim Uygulamasını Hemen indirin</h3>
            <div className="download-buttons">
              <button 
                className="download-btn google-play"
                onClick={() => window.open('https://play.google.com/store/apps/details?id=com.microfinanceas.taxicim', '_blank')}
              >
                <div className="btn-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5v14l11-7z"/>
                  </svg>  
                </div>
                <div className="btn-text">
                  <span>Hemen indirin</span>
                  <span>Google Play</span>
                </div>
              </button>
              <button 
                className="download-btn app-store"
                onClick={() => window.open('https://apps.apple.com/tr/app/taxicim/id6747424960', '_blank')}
              >
                <div className="btn-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" fill="currentColor"/>
                  </svg>
                </div>
                <div className="btn-text">
                  <span>Hemen indirin</span>
                  <span>App Store</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="#FFC107" strokeWidth="2"/>
                  <polyline points="22,6 12,13 2,6" stroke="#FFC107" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Email Adresimiz</h4>
              <p>destek@taxicim.com.tr</p>
            </div>
            <div className="footer-section">
              <div className="footer-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92V19.92C22 20.49 21.8 21.05 21.41 21.41C21.02 21.78 20.49 22 19.92 22C8.11 22 2 15.89 2 4.08C2 3.51 2.22 2.98 2.59 2.59C2.95 2.2 3.51 2 4.08 2H7.09C7.32 2 7.54 2.1 7.7 2.27C7.86 2.44 7.95 2.67 7.94 2.91L7.82 4.37C7.8 4.72 7.69 5.05 7.5 5.32C7.31 5.6 7.04 5.8 6.73 5.91L5.61 6.29C5.61 6.29 6.51 10.92 10.59 14C14.68 17.49 19.31 18.39 19.31 18.39L19.69 17.27C19.8 16.96 20 16.69 20.27 16.5C20.55 16.31 20.88 16.2 21.23 16.18L22.69 16.06C22.93 16.05 23.16 16.14 23.33 16.3C23.5 16.46 23.6 16.68 23.6 16.91L22 16.92Z" stroke="#FFC107" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Bize Ulaşın</h4>
              <p>08502428876</p>
              <a 
                href="https://wa.me/908502428876"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  color: '#25D366',
                  textDecoration: 'none',
                  marginTop: '0.5rem',
                  fontSize: '1.1rem',
                  fontWeight: 'bold'
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564c.173.087.289.129.332.202.043.073.043.423-.101.828z"/>
                </svg>
                WhatsApp İletişim
              </a>
              <div className="account-delete-section">
                <button 
                  className="account-delete-btn"
                  onClick={() => navigate('/destek')}
                  style={{ marginBottom: '1rem' }}
                >
                  🛠️ Destek Merkezi
                </button>
                <button 
                  className="account-delete-btn"
                  onClick={() => navigate('/hesap-silme-talebi')}
                >
                  Silinmesini istediğiniz hesabı buradan bildiriniz
                </button>
              </div>
            </div>
            <div className="footer-section">
              <div className="footer-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.3639 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="#FFC107" strokeWidth="2"/>
                  <circle cx="12" cy="10" r="3" stroke="#FFC107" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Adresimiz</h4>
              <p>
                Atatürk Mah. Ertuğrul Gazi Sok. Metropol İstanbul A Blok Apt 
                No:2E Kat:21 Daire:331 Ataşehir / İstanbul
              </p>
            </div>
            <div className="footer-section">
              <div className="footer-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 2H7C5.89 2 5 2.89 5 4V20C5 21.11 5.89 22 7 22H17C18.11 22 19 21.11 19 20V4C19 2.89 18.11 2 17 2Z" stroke="#FFC107" strokeWidth="2"/>
                  <polyline points="9,9 9,18 15,18 15,9" stroke="#FFC107" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Sosyal Medya</h4>
              <div className="social-media-links">
                <button 
                  className="social-btn facebook"
                  onClick={() => window.open('https://www.facebook.com/taxicimtr?locale=tr_TR', '_blank')}
                  title="Facebook"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </button>
                                 <button 
                   className="social-btn instagram"
                   onClick={() => window.open('https://www.instagram.com/taxicimtr?igsh=cjk4cmY0djFiNGQ0', '_blank')}
                   title="Instagram"
                 >
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                     <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                   </svg>
                 </button>
                <button 
                  className="social-btn twitter"
                  onClick={() => window.open('https://x.com/taxicimtrtr?s=21', '_blank')}
                  title="Twitter/X"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </button>
                <button 
                  className="social-btn tiktok"
                  onClick={() => window.open('https://www.tiktok.com/@taxicimtr?_t=ZS-8xapjArxShr&_r=1', '_blank')}
                  title="TikTok"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                </button>
                <button 
                  className="social-btn youtube"
                  onClick={() => window.open('https://www.youtube.com/@taxicim', '_blank')}
                  title="YouTube"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-logo">
              <h3>Taxicim</h3>
              <p>
                Artık trafik sıkışıklıkları veya park yeri bulma derdi olmadan şehrinizi 
                keşfedin. Hızlı, güvenilir ve konforlu bir ulaşım deneyimi için bizi tercih edin. 
                Şehrinizin yeni ulaşım asistanı olarak, sizlere her zaman en iyisini sunmak için buradayız.
              </p>
            </div>
            <div className="copyright">
              <p>© 2025 Taxicim. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>


    </div>
  );
};

export default HomePage; 